import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Quote from '../../../components/Quote';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';
import styles from './index.module.scss';

import cheryl from './cheryl.jpg';
import gladys from './gladys.jpg';
import kylie from './kylie.jpg';
import queenie from './queenie.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="alumni-testimonials">
    <h1>Alumni Testimonials</h1>
    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${cheryl})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>Cheryl Ting</div>
          <div className={styles.classOf}>KIS Class of 2013</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          I attended Kingston from 2005 to 2013, joining kindergarten and graduating after the Primary Years Programme
          (PYP).
        </p>
        <p>
          Kingston has sculpted me into not only the learner, but the person I am today. I have learnt to be responsible
          and hard-working, to manage my time well and take care of myself, to always care and empathize others around
          us, to take action and lead a positive change in our community, inside and outside of school and the world (I
          still remember writing a letter, as a class, to Malala Yousafzai). I don’t think I will ever forget completing
          the (almost) monthly IB learner reflections: I honestly never liked them, but looking back, they have taught
          me the pillars of teamwork, the significance of communication, the value of creativity, the beauty in
          diversity, the power of unity... I have no words to explain how grateful I am to have learnt these early on in
          my life, for they have now become an integral part of who I am and helped me overcome countless obstacles the
          small (literally) and immature me would never have imagined.
        </p>
        <p>
          Education almost takes on a different definition in Kingston. The excursions, experiments, projects,
          activities and events create a unique learning experience, which, in combination with the principles of the
          PYP, have sculpted me into developing some extremely crucial learning habits and having an optimistic attitude
          to towards learning. Having a passion and love for learning is much more important than achieving the highest
          grade, as impossible as that may sound, because that is what stays with us forever, even into adulthood-
          learning is a never-ending process.
        </p>
        <p>
          Graduating from Kingston was really difficult for me- I had spent my whole life with the same group of 20 more
          people, and the thought of everyone leaving for separate paths just seemed like the end of the world.
          Transitioning to CIS, despite how all the great words I had heard of it, did not appeal to me anywhere as much
          as I wanted to hop on a time machine and fly two years back. However, I am glad to say that even five years
          later, no one has really left- our spirits and energy and care for each other could still be found between the
          lines of every conversation over Facebook, during every reunion party. Kingston is a much smaller community in
          comparison to other schools, but this only proves how it is capable of cultivating stronger, tighter bonds
          between not only students, but teachers as well.
        </p>
        <p>
          Even now, I am extremely grateful for how Kingston has prepared me for my current pursuits in the MYP
          programme moving into the IBDP, not to mention the memories that I continue to treasure.
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${gladys})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>Gladys Kwok</div>
          <div className={styles.classOf}>KIS Class of 2017</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          I am very thankful and grateful for everything Kingston has done for me. As I reflect on the past, I realize
          that Kingston was not an ordinary school. It was a school with laughter and joy and was irreplaceable.
          Kingston means a lot to me as I have been part of this community ever since I was 2, it was basically like my
          other family. I am grateful for how Kingston has shaped me into who I am today, and thankful to all the great
          memories and achievements there. Even now while I’m in Secondary School, I still think back to the memories I
          had in Kingston. How wonderful it was to grow and learn from educated teachers alongside my fellow classmates.
          My time at Kingston gave me many wonderful memories such as the Spring Concerts which we performed “Joust” a
          musical while in Year 6, the Xi’an trip, field trips, The PYP Exhibition which my topic was “Poverty and
          Homelessness”, the P5 camp and the never forgotten Graduation in which I was the MC of. When my time in
          Kingston wrapped up it was a really difficult time as I shared so much laughter and joy with my peers who I
          had known for so long and was educated alongside. This time has come and gone. I would really have liked to
          continue at primary school but I know that this could not happen as I have to move on to my own paths and find
          my own way to fulfil my dreams. I believe that what Kingston has taught me will never be forgotten and will
          pay off in the future.
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${kylie})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>Kylie Wang Yu Xin</div>
          <div className={styles.classOf}>KIS Class of 2017</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          I am grateful for everything Kingston has done for me. As I reflect back upon it now, I realise how quickly
          the six years have gone by, yet in that seemingly short time Kingston has shaped me into who I am today.
          Kingston means a lot to me—it was another home, and all my fellow classmates and all the wonderful teachers
          are a family. I have had a lot of wonderful experiences. From field trips, to camping, to an Overseas Trip, to
          Spring Concert, and our final and biggest exhibition—the PYP exhibition… Kingston has brought us everywhere
          you could possibly go in learning. You cannot imagine how sad I was when it was time, at last, to leave.
          Kingston teaches us, and nurtures us to grow in all different directions, and it has taught us to continue to
          grow even after we left its care to go on, each on our own unique paths, to travel to places nobody else have
          been. As I move onwards, in the future, whenever people ask, I shall be glad to tell them that I spent my six
          glorious years of primary at Kingston International School.
        </p>
      </Quote>
    </div>

    <div className={styles.quote}>
      <div className={styles.person}>
        <div className={styles.photo} style={{ backgroundImage: `url(${queenie})` }} />
        <div className={styles.cite}>
          <div className={styles.name}>Queenie Chan</div>
          <div className={styles.classOf}>KIS Class of 2017</div>
        </div>
      </div>
      <Quote className={styles.text}>
        <p>
          I am very thankful for all the things Kingston has done for me. I have always thought back on the things that
          I had done during the time I was at Kingston, and how it has changed and helped me to improve. Kingston is
          something that means a lot to me, as if it was part of me. I remembered when me and some of my friends had
          took action about people polluting the ocean and made an presentation in front of the whole upper primary when
          I was in P4, it was one of my most wonderful experiences, one that I would never forget... I had also made a
          lot of great friends and teachers during all these six years. And yet, even though these years went past in a
          flash, they were very important to me, and without them, I wouldn't have gone to this stage of my life. In
          Kingston, I had made a lot of memories, achievements, and I have had a lot of different challenges, good ones,
          and bad ones. Field trips to many different places, P5 camp, many different projects, exhibitions, sports
          days, spring concerts, P6 Overseas Trip to Xi'an, and our extremely important PYP exhibition. The PYP
          exhibition was in P6. When our time in Kingston slowly came to an end, it was hard to even imagine how sad it
          had felt. Leaving all of our classmates, school, and teachers and everything we have known for so long. But
          this part of our life, this step was something we must do, we must continue the path that has been made for us
          and move onwards, remembering the memories, the experiences, and the things that Kingston has taught us during
          the six years we have been there. And sooner or later, one day, I am sure that our paths would come together
          again.
        </p>
      </Quote>
    </div>
  </ContentLayout>
);
